export default "__VITE_ASSET__2fuRH8Lo__"